// extracted by mini-css-extract-plugin
export default {"priceFormContainer":"PriceFormTabs_priceFormContainer__-7HUQ"};